export type ThreatIconId =
  | 'invasive-species'
  | 'agriculture'
  | 'climate-change'
  | 'hunting'
  | 'pollution'
  | 'urban-development'
  | 'human-disturbance'
  | 'fisheries'
  | 'energy'
  | 'logging'
  | 'multiple';

type ThreatIconProps = {
  id: ThreatIconId;
  className?: string;
};

const THREAT_ICON_SRC: Record<ThreatIconId, string> = {
  'invasive-species': '/svg/threat-icons/invasive-species.svg',
  agriculture: '/svg/threat-icons/agriculture.svg',
  'climate-change': '/svg/threat-icons/climate-change.svg',
  hunting: '/svg/threat-icons/hunting.svg',
  pollution: '/svg/threat-icons/pollution.svg',
  'urban-development': '/svg/threat-icons/urban-development.svg',
  'human-disturbance': '/svg/threat-icons/human-disturbance.svg',
  fisheries: '/svg/threat-icons/fisheries.svg',
  energy: '/svg/threat-icons/energy.svg',
  logging: '/svg/threat-icons/logging.svg',
  multiple: '/svg/threat-icons/multiple.svg',
};

/**
 * Figma threat-category vectors (`673:66272` DataZone icons).
 * Decorative when paired with visible card labels (`aria-hidden`).
 */
export function ThreatIcon({ id, className }: ThreatIconProps) {
  return (
    // eslint-disable-next-line @next/next/no-img-element -- inline SVG asset (ADR-004)
    <img
      src={THREAT_ICON_SRC[id]}
      alt=""
      aria-hidden
      className={className}
      width={49}
      height={42}
      decoding="async"
    />
  );
}
